(function (Drupal, $) {

  $(function () {
    $('.user-content #edit-pass .password-parent input').on('input', function () {
      $(this).parent().find('.password-strength__text').removeClass('is-weak').removeClass('is-good').removeClass('is-strong').removeClass('is-fair');
      if ($(this).parent().find('.password-strength__indicator').hasClass('is-weak')) {
        $(this).parent().find('.password-strength__text').addClass('is-weak');
      } else if ($(this).parent().find('.password-strength__indicator').hasClass('is-good')) {
        $(this).parent().find('.password-strength__text').addClass('is-good');
      } else if ($(this).parent().find('.password-strength__indicator').hasClass('is-fair')) {
        $(this).parent().find('.password-strength__text').addClass('is-fair');
      } else {
        $(this).parent().find('.password-strength__text').addClass('is-strong');
      }
    });
    $(".user-form input[type='tel'], .user-pass input[type='tel'], .webform-submission-form input[type='tel']").on('input', function(e) {
      $(this).val($(this).val().replace(/[^+0-9]/g, ''));
    });
  });
})(Drupal, jQuery);
